<div
  class="flex flex-col py-6 px-4 bg-white max-w-[520px] mx-auto items-center"
>
  <ui-headline
    type="h16"
    mobile-type="h16"
    text-color="neutrals-900"
    font-weight="bold"
    content="Código de despacho"
  />
  <ui-headline
    class="mt-2 text-center"
    type="h14"
    mobile-type="h14"
    text-color="neutrals-900"
    font-weight="regular"
    content="Ingresa el código entregado por el ferretero para confirmar la entrega."
  />
  <digicem-pin-field
    class="my-4"
    [numOfDigits]="4"
    [hasError]="hasError"
    (codeFilled)="onCodeFilled($event)"
  ></digicem-pin-field>

  <div class="w-full flex flex-col gap-1">
    <div
      class="flex items-center justify-between pr-2 py-2 pl-3 self-stretch rounded-[4px] border border-neutrals-300 bg-neutrals-100 w-full gap-3"
    >
      <ui-paragraph
        type="p10"
        mobile-type="p10"
        text-color="neutrals-700"
        font-weight="medium"
        content="N° Pedido"
      />
      <ui-paragraph
        class="text-end leading-tight"
        type="p10"
        mobile-type="p10"
        text-color="neutrals-900"
        font-weight="semibold"
        [content]="order.orderNumber"
      />
    </div>

    <div
      class="flex items-center justify-between pr-2 py-2 pl-3 self-stretch rounded-[4px] border border-neutrals-300 bg-neutrals-100 w-full gap-3"
    >
      <ui-paragraph
        type="p10"
        mobile-type="p10"
        text-color="neutrals-700"
        font-weight="medium"
        content="Ferretería"
      />
      <ui-paragraph
        class="text-end leading-tight"
        type="p10"
        mobile-type="p10"
        text-color="neutrals-900"
        font-weight="semibold"
        [content]="order.commercialName"
      />
    </div>
    <digicem-product-accordion
      *ngFor="let product of order.products; let i = index"
      [title]="getTitleProduct(i)"
      [productName]="product.productName"
      [quantityText]="getQuantityProduct(product)"
    ></digicem-product-accordion>
  </div>
  <div class="flex flex-col mt-6 gap-2 items-stretch w-full">
    <ui-button
      type="primary"
      responsive="false"
      size="md"
      button-text="Confirmar entrega"
      [isLoading]="isLoading"
      [enabled]="isValidCode"
      (click)="onConfirmDelivery()"
    ></ui-button>
    <ui-button
      type="secondary"
      responsive="false"
      size="md"
      button-text="Cancelar"
      (click)="onCancel()"
    ></ui-button>
  </div>
</div>
